import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Color } from './Components/Palette'; // Change 'palette' to 'Color'
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Color color1="#ffff00" color2="#fe00fe" color3="#00ffff" color4="#fe0000" color5="#00ff00" color6="#0000fe" color7="#008000" color8="#fe6347" color9="#00cfd1" color10="#fea500" color11="#81007f" color12="#ffc0cb" color13="#8b4413" color14="#ff8b00" color15="#4683b4" color16="#fed700" />
);

reportWebVitals();
